import {Link, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useGetJson, useInterval} from "../../../hooks";
import {config, endpoints, minToVerboseTime} from "../../../utils2";
import {Badge} from "react-bootstrap";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";
import {TableLikeText} from "../../_components";
import {WhiteCard} from "../_components/WhiteCard";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";

export function OnlineSection({device}) {
    return <>
        <WhiteCard className="flex-fill">
            <OnlineCard device={device}/>
        </WhiteCard>
    </>
}

function OnlineCard({device}) {
    const rtcc = useTopicSSE(SseTopics.RTCC)
    const online = useTopicSSE(SseTopics.Online)

    const [runtime, setRuntime] = useState(0)

    const [prod, loadingProd, errorProd, clearErrorProd] = useGetJson(endpoints.product.query(device?.device_project))
    const product = prod?.data
    const media_src = config.get_public_media(product?.medias[0].path, "thumb")

    useEffect(() => {
        const diff = Number(rtcc?.date) - Number(rtcc?.tstamp)
        setRuntime(online && rtcc?.date && rtcc?.tstamp ? diff : 0)
    }, [online, rtcc])

    useInterval(() => {
        if (online) {
            setRuntime(prev => prev > 0 ? prev + 30 : 0)
        }
    }, 30000, [online])

    return <>
        <div className="d-flex align-items-start gap-1">
            <div className="d-flex  gap-2">
                <Badge bg={online ? "success" : "danger"} className="mb-2">
                    <div className="d-flex align-items-center gap-2">{online ? "ONLINE" : "OFFLINE"} <i
                        className={online ? "fs-5 bi bi-cloud" : "fs-5 bi bi-cloud-slash"}/></div>
                </Badge>
                {online && <ABOverlayTooltip placement="right" tip="Uptime">{online && minToVerboseTime(runtime / 60)}</ABOverlayTooltip>}
            </div>
            <div className="ms-auto">
                {media_src ? <Link to={`/shop/detail/${product.id}`}><img
                    src={media_src}
                    alt="Device"
                    height="80px"
                    width="80px"
                    style={{borderRadius: "8px", minWidth: "60px"}}
                    loading="lazy"
                    className="mb-0"
                /></Link> : null}
            </div>
        </div>
        <div className="d-flex flex-column mb-2">
            <TableLikeText title="Model" value={<Link to={`/shop/detail/${product?.id}`}
                                                      className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                {device?.device_project}</Link>}/>
            <TableLikeText title="Serial" value={device?.device_serial}/>
        </div>
    </>
}